import { Table, Input } from 'antd';
import { useState, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Loader } from '../../components/Loader';
import { PageHeader } from '../../components/PageHeader';

import { defaultPageSize } from '../../settings/settings';

import { useMyCompanyListColumns } from './useMyCompanyListColumns';
import { useMyCompanyListData } from './useMyCompanyListData';

export const MyCompanies = () => {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [filterTable, setFilterTable] = useState();
  const { myCompanyListData, myCompanyListTotal, loading } = useMyCompanyListData();
  const columns = useMyCompanyListColumns();

  const search = value => {
    if (value == '') {
      setFilterTable(myCompanyListData);
    }

    const filterTableData = myCompanyListData.filter(o =>
      ['name', 'dhl_ids', 'tax_id'].some(k => String(o[k]).toLowerCase().includes(value.toLowerCase())),
    );

    setFilterTable(filterTableData);
  };

  useLayoutEffect(() => {
    setFilterTable(myCompanyListData);
  }, [myCompanyListData]);

  return (
    <>
      <PageHeader
        titleTranslationKey='myCompanies.myCompanies'
        extra={
          <>
            <Input.Search placeholder={t('myCompanies.search')} enterButton onSearch={search} />
          </>
        }
      />

      <Loader loading={loading}>
        <Table
          rowKey='_id'
          tableLayout='auto'
          dataSource={filterTable}
          columns={columns}
          loading={loading}
          scroll={{ x: 'max-content' }}
          pagination={{
            current: page,
            pageSize: defaultPageSize,
            total: myCompanyListTotal,
            showTotal: total => t('global.tableTotal', { total }),
            showSizeChanger: false,
            hideOnSinglePage: true,
            onChange: setPage,
          }}
        />
      </Loader>
    </>
  );
};
